import React, { Component } from 'react';
import { Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import ErrorMessage from '../../components/ErrorMessage';
import TopBar from '../../components/TopBar'; // Import the TopBar component

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

const ContentContainer = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: #edf4ff;
  padding: 30px;
  border-radius: 5px;
  margin-top: 20px;
`;

const Heading = styled.h1`
  margin-top: 0;
  color: #333;
`;

const SubscriptionDetails = styled.div`
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .cancel-button,
  .upgrade-button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1rem;
    color: white;
  }

  .cancel-button {
    background-color: #dc3545;
  }

  .upgrade-button {
    background-color: #007bff;
  }
`;

@inject('notesStore')
@observer
class AccountPage extends Component {
  state = {
    subscription: null,
    loading: true,
    errorMessage: null,
  };

  async componentDidMount() {
    try {
      const paymentPlan = await this.props.notesStore.getPaymentPlan();
      console.log(`payment plan: ${paymentPlan}`);
      this.setState({ subscription: paymentPlan, loading: false });
    } catch (error) {
      this.setState({ errorMessage: error.message, loading: false });
    }
  }

  handleCancel = async () => {
    window.location.hash = '/cancellation';
  };

  handleUpgrade = async () => {
    window.location.hash = '/payment';
  };

  render() {
    const { subscription, loading, errorMessage } = this.state;

    return (
      <PageContainer>
        <TopBar /> {/* Add the TopBar component here */}
        <ContentContainer>
          <Heading>Account Details</Heading>
          
          {loading && <Typography>Loading...</Typography>}
          {errorMessage && <ErrorMessage message={errorMessage} />}
          
          {subscription && (
            <SubscriptionDetails>
              <Typography variant="h6">Current Subscription</Typography>
              <Typography><strong>Plan:</strong> {subscription.data}</Typography>
              
              <ButtonContainer>
                <Button onClick={this.handleCancel} className="cancel-button">
                  Cancel Subscription
                </Button>
                <Button onClick={this.handleUpgrade} className="upgrade-button">
                  Upgrade Subscription
                </Button>
              </ButtonContainer>
            </SubscriptionDetails>
          )}
        </ContentContainer>
      </PageContainer>
    );
  }
}

export default AccountPage;
